import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import pathConfiguration from 'src/configuration/path'
import { Button } from '~/core/ui/Button'
import IconWrapper from '~/core/ui/IconWrapper'

interface Props {
  className?: string
  label?: string
}

const ContactRequestButton: FC<Props> = ({ className, label }) => {
  const { t, i18n } = useTranslation()

  return (
    <Link
      href={pathConfiguration.contactRequest}
      locale={i18n?.language}
      className={className}>
      <Button
        fontWeight="font-medium"
        size="xl"
        className="w-auto"
        type="secondary">
        <div className="flex items-center gap-2 px-1 text-gray-600">
          {label || t('lp:talks_to_us')}
          <IconWrapper size={20} name="ArrowUpRight" color="gray" />
        </div>
      </Button>
    </Link>
  )
}

export default ContactRequestButton
